import { SoftLabelsHttpService } from "./services/soft-labels-http.service"
import { SoftLabelsEffects } from "./effects/soft-labels"

export const softlabelsServices = [
  SoftLabelsHttpService
];

export const softlabelsEffects = [
  SoftLabelsEffects
];
